/* get listener ready */
ats.listener = window.Echo;

$(document).ready(function () {

    /* check for others presence */
    $('body').on({
        'mouseover': function () {
            var channel = $(this).data('presence');
            if (channel != "") {
                ats.listener.join(channel).here((users) => {
                    var users_present = ats.othersInPresenceArray(user_id, users, 'array');
                    if (users_present.length > 0) {
                        var firstKey = Object.keys(users_present)[0];
                        var title = users_present[firstKey].name + ' is currently editing.';
                        $(this).data('title', title).attr('title', title).data('toggle', 'tooltip').data('placement', 'top').tooltip('show');
                    }
                });
            }
        },
        'mouseleave': function () {
            var channel = $(this).data('presence');
            if (channel != "") {
                ats.listener.leave(channel);
                $(this).tooltip('dispose').attr('title', $(this).data('original-title'));
            }
        }
    }, '[data-presence]');

});
/* END DOC RDY */

/* logout listener */
ats.logoutListener = function (route, channel = user_id) {
    ats.listener.private("user." + channel).listen('.logout', (e) => {
        setTimeout(function () {
            ats.alerts.confirmRedirect("Logged Out", "You logged out from another window, please refresh this page to log in again and return, or log in via another tab and dismiss this to prevent losing any changes you may have made.", route);
        }, 5000);
    });
}

/* presence checking */
ats.othersInPresenceArray = function (needle, haystack, rt = 'bool') {
    var length = haystack.length;
    var counter = [];
    for (var i = 0; i < length; i++) {
        if (haystack[i]['id'] != needle) counter.push(haystack[i]);
    }

    if (rt == 'bool') {
        if (counter.length > 0) return true;
        return false;
    } else {
        return counter;
    }
}

ats.addPresenceAlert = function (users_array) {
    $.each(users_array, function (id, record) {
        if (!$("#editing_" + record.id).length) {
            var data = [];
            data.id = "editing_" + record.id;
            data.type = "danger";
            data.content = "<strong>Warning</strong> " + record.name + " is also editing this.";
            $("#presence_alerts").append(ats.curly('alert_tpl', data));
        }
    });
}

ats.addPresenceToast = function (users_array) {
    $.each(users_array, function (id, record) {
        ats.alerts.toast("<strong>Warning</strong> " + record.name + " is also editing this.", 'warning');
    });
}

ats.editingPresenceAlert = function (user_editing, users) {
    $("#presence_alerts").html('');
    var users_present = ats.othersInPresenceArray(user_editing, users, 'array');
    if (users_present.length > 0) {
        ats.addPresenceAlert(users_present);
    }
}

ats.editingDuplicateAlert = function (user_editing) {
    if (!$("#editing_" + user_editing).length) {
        var data = [];
        data.id = "editing_" + user_editing;
        data.type = "warning";
        data.content = "<strong>Warning</strong> You opened this in another window, if you made changes there, be careful not to overwite them here.";
        $("#presence_alerts").append(ats.curly('alert_tpl', data));
    }
}

ats.presenceCheck = function (user_editing, channel, route) {
    ats.listener.join(channel)
        .here((users) => { ats.editingPresenceAlert(user_editing, users); })
        .joining((user) => { ats.addPresenceToast([user]); })
        .leaving((user) => { if ($("#editing_" + user.id).length) { $("#editing_" + user.id).remove(); ats.alerts.confirmRedirect("Please Refresh", "You should refresh the page to avoid overwriting the changes " + user.name + " made.", route); } })
        .listen('.edit', (e) => {
            if (e.payload.id == user_editing) {
                ats.editingDuplicateAlert(user_editing);
            } else {
                ats.addPresenceAlert([e.payload]);
            }
        });
}

/* notification actions */
$(document).on('click', '.notification-complete', function (e) {
    var $id = $(this).data('id');
    Livewire.dispatch('completeNotification', {task_id: $id});
});
if (typeof Livewire !== 'undefined') {
    Livewire.on('complete', function () {
        $('#remoteModal').modal('hide');
    });
}

$(document).on('click', '.notification-snooze', function (e) {
    var $id = $(this).data('id');
    Livewire.dispatch('snoozeNotification', {task_id: $id});
});
if (typeof Livewire !== 'undefined') {
    Livewire.on('snooze', function () {
        $('#remoteModal').modal('hide');
    });
}

$(document).on('click', '.notification-view', function (e) {
    var $id = $(this).data('id');
    ats.modal.load('/reminders/view/' + $id, 'View Task', 1, 'modal-lg', 0, 0);
});

/* notification toast */
ats.notification = function (payload, type="info"){
    switch (payload.action) {
        case 'phone':
            var title = "Phone Call";
            break;
        case 'video':
            var title = "Video Call";
            break;
        case 'email':
            var title = "Email";
            break;
        case 'meet':
            var title = "Meeting";
            break
        case 'form':
            var title = "Form";
            break
        case 'post':
            var title = "Post";
            break;
    }
    toastr[type](
        "<small>" + payload.description + "</small><br />"
        + "<button type=\"button\" class=\"btn btn-sm btn-light mr-1 clear notification-view\" data-id=\"" + payload.id + "\">View</button>"
        + "<button type=\"button\" class=\"btn btn-sm btn-light mr-1 clear notification-complete\" data-id=\"" + payload.id + "\">Mark Complete</button>"
        + "<button type=\"button\" class=\"btn btn-sm btn-light clear notification-snooze\" data-id=\"" + payload.id + "\">Snooze</button>",
        title,
        { "debug": false, "timeOut": 0, "extendedTimeOut": 0, "tapToDismiss": true, "escapeHtml": false }
    );

    Livewire.emit('newNotification');
}

/* notifiction listeners */
ats.userNotifications = function (channel = user_id) {
    ats.listener.private("user." + channel).listen('.notification', (e) => {
        ats.notification(e.payload);
    });
}

ats.accountNotifications = function (channel = account_id) {
    ats.listener.private("account." + channel).listen('.notification', (e) => {
        ats.notification(e.payload);
    });
}
